/* NSH quiz - back to your own result (v13.12, 2026-10-17). ASCII only.
   Loaded by templates/page.nsh-quiz.liquid right before nsh-quiz-engine-1.js (not deferred), so part 1 runs
   before engine-2's ?state= boot and v12's initial().
   1) seed: ?state=<slug>&a=<answers> WITHOUT ref=share and WITHOUT by= is the reader's own result link. When
      localStorage nshQuizR is empty or different, it is written from the URL, so engine-2 / v12 restore the
      OWNER view (Instagram / Kakao in-app browsers can drop localStorage after an article opens).
      ref=share or by= : nothing here (friend view stays as it was). ?qa= : nothing here.
   2) URL: after a fresh finish (and after an owner restore) the address carries state + a (+ c2, d, and
      joined=1 once the gate is open) via history.replaceState. Never email, never ref / by.
   3) gate: on a real submit of #waitForm, joined=1 goes into the URL and return_to also carries a / c2 / d.
      joined=1 only ever counts in the owner view (engine-2 / v12 ignore it in the shared view; v13 never
      gates the friend view).
   4) scroll: leaving the result (link click, pagehide, tab hidden) stores scrollY in sessionStorage
      nshRetY:<slug>; when the same result loads again (reload or bfcache) it goes back there instead of the
      top. A fresh finish starts at the top; start() (new quiz) clears the stored positions.
   5) engine-2 shareUrl (card share) drops joined / cta / v13gate / v13owner.
   No tracking events are sent from this file. */
(function(){
  if(window.__NSH_RET)return; window.__NSH_RET=1;
  var W=window,D=document;
  var SLUGS={P1F:'quiet-drought',P1T:'cracked-drought',P2F:'disguised-dryness',P2T:'prickly-dryness',P3F:'diligent-sebum',P3T:'overtime-sebum',P4F:'steady-rhythm',P4T:'missed-beat'};
  var A_RE=/^[0-9]{8,40}$/,PFX='nshRetY:',MAXAGE=12*3600*1000;
  function keyOf(s){for(var k in SLUGS){if(Object.prototype.hasOwnProperty.call(SLUGS,k)&&SLUGS[k]===s)return k}return ''}
  function sp(){try{return new URL(location.href).searchParams}catch(e){return null}}
  function friendUrl(q){return !!q&&(q.get('ref')==='share'||!!q.get('by'))}
  function ownerUrl(q){return !!q&&!friendUrl(q)&&!q.get('qa')&&!!keyOf(q.get('state')||'')}

  /* ---- 1) seed nshQuizR from an own result link ---- */
  var Q0=sp();
  try{
    if(ownerUrl(Q0)){
      var s0=Q0.get('state'),a0=Q0.get('a')||'',k0=keyOf(s0);
      if(A_RE.test(a0)){
        var cur=null;try{cur=JSON.parse(localStorage.getItem('nshQuizR')||'null')}catch(e){cur=null}
        if(!(cur&&cur.k===k0&&Array.isArray(cur.a)&&cur.a.join('')===a0)){
          localStorage.setItem('nshQuizR',JSON.stringify({k:k0,a:a0.split('').map(Number)}));
          W.__nshRetSeeded=1;
        }
      }
    }
  }catch(e){}

  /* ---- helpers ---- */
  function hasJoined(){try{return localStorage.getItem('nshJoined')==='1'}catch(e){return false}}
  function shown(){var r=D.getElementById('result');return !!(r&&!r.classList.contains('hidden'))}
  function friendNow(){if(friendUrl(sp()))return true;try{if(W.NSH_V13_API&&W.NSH_V13_API.friendView())return true}catch(e){}return false}
  function ans(){var a=String(W.__ans||'');return A_RE.test(a)?a:''}
  function c2Now(){try{var c=W.NSH_V12_API&&W.NSH_V12_API.ctx();return (c&&c.codes&&c.codes[1])||''}catch(e){return ''}}
  function dNow(){try{var d=W.__nshD;if(d&&typeof d==='object')return Object.keys(d).map(function(k){return k+String(d[k]||0)}).join('')}catch(e){}return ''}
  function slugNow(){var q=sp();return (q&&q.get('state'))||''}
  function ownParams(u,joined){
    var p=u.searchParams,a=ans();if(!a)return false;
    p.set('a',a);
    var c2=c2Now();if(c2)p.set('c2',c2);else p.delete('c2');
    var d=dNow();if(d)p.set('d',d);else p.delete('d');
    if(joined)p.set('joined','1');
    return true;
  }

  /* ---- 2) keep the own result link in the address bar ---- */
  function syncUrl(fresh){
    try{
      if(!history.replaceState||!shown()||!ans())return;
      var u=new URL(location.href),p=u.searchParams;
      if(!keyOf(p.get('state')||''))return;
      if(fresh){p.delete('by');if(p.get('ref')!=='share')p.delete('ref')}   /* a new run is always the reader's own */
      if(friendUrl(p)||(!fresh&&friendNow()))return;
      if(!ownParams(u,hasJoined()))return;
      var next=u.toString();if(next!==location.href)history.replaceState(history.state,'',next);
    }catch(e){}
  }
  function syncSoon(fresh){[0,600,1500,3000,6000].forEach(function(ms){setTimeout(function(){syncUrl(fresh)},ms)})}

  /* ---- 4) scroll position per result ---- */
  var restoring=false,noSave=false,pendingFresh=false;
  function rk(s){return PFX+s}
  function save(){
    if(noSave||restoring)return;
    try{var s=slugNow();if(!s||!shown())return;
      W.sessionStorage.setItem(rk(s),JSON.stringify({y:Math.round(W.pageYOffset||D.documentElement.scrollTop||0),a:(sp()&&sp().get('a'))||ans(),t:Date.now()}))}catch(e){}
  }
  function clearAll(){try{var ss=W.sessionStorage,ks=[];for(var i=0;i<ss.length;i++){var k=ss.key(i);if(k&&k.indexOf(PFX)===0)ks.push(k)}ks.forEach(function(k){ss.removeItem(k)})}catch(e){}}
  function saved(){
    try{var s=slugNow();if(!s)return null;var r=JSON.parse(W.sessionStorage.getItem(rk(s))||'null');
      if(!r||typeof r.y!=='number'||r.y<=0||Date.now()-(+r.t||0)>MAXAGE)return null;
      var a=(sp()&&sp().get('a'))||'';if(a&&r.a&&r.a!==a)return null;
      return r}catch(e){return null}
  }
  function gateFlag(){try{return W.sessionStorage.getItem('nshGateAnchor')==='1'}catch(e){return false}}
  function restoreScroll(){
    var r=saved();if(!r||gateFlag())return;
    restoring=true;var stop=false,n=0;
    var halt=function(){stop=true;restoring=false};
    ['wheel','touchstart','keydown','mousedown'].forEach(function(ev){W.addEventListener(ev,halt,{passive:true,once:true})});
    var go=function(){if(stop||!shown())return;var y=Math.min(r.y,Math.max(0,(D.documentElement.scrollHeight||0)-(W.innerHeight||0)));if(Math.abs((W.pageYOffset||0)-y)>4){W.scrollTo(0,y);n++}};
    [150,500,1000,1700,2600,3800,5200,7000].forEach(function(ms){setTimeout(go,ms)});
    setTimeout(function(){restoring=false;W.__nshRetScroll={y:r.y,moved:n,stopped:stop}},7300);
  }

  /* ---- wiring after every patch has loaded ---- */
  function wrap(){
    try{if(typeof W.finish==='function'&&!W.finish.__nshRet){var f0=W.finish;var f=function(o){var out=f0.apply(this,arguments);try{
        if(!(o&&o.restore)){pendingFresh=true;clearAll();syncSoon(true)}
        else if(!(o&&o.shared))syncSoon(false)}catch(e){}return out};f.__nshRet=1;W.finish=f}}catch(e){}
    try{if(typeof W.start==='function'&&!W.start.__nshRet){var s0=W.start;var g=function(){clearAll();return s0.apply(this,arguments)};g.__nshRet=1;W.start=g}}catch(e){}
    try{if(typeof W.shareUrl==='function'&&!W.shareUrl.__nshRet){var u0=W.shareUrl;var h=function(){var u=u0.apply(this,arguments);try{var x=new URL(u);['joined','cta','v13gate','v13owner'].forEach(function(k){x.searchParams.delete(k)});u=x.toString()}catch(e){}return u};h.__nshRet=1;W.shareUrl=h}}catch(e){}
  }
  function init(){
    wrap();var n=0;(function again(){wrap();if(++n<30)setTimeout(again,200)})();   /* other patches wrap finish / start / shareUrl on timers too */
    /* owner restore on load: the URL may be an old one (?state= only); bring it up to date */
    if(ownerUrl(sp()))syncSoon(false);
    restoreScroll();
    /* 3) gate submit (joinWaitlist did not cancel it) */
    D.addEventListener('submit',function(ev){try{var f=ev.target;if(!f||f.id!=='waitForm'||ev.defaultPrevented||friendNow())return;
      noSave=true;var s=slugNow();if(s)W.sessionStorage.removeItem(rk(s));
      var u=new URL(location.href);if(keyOf(u.searchParams.get('state')||'')){ownParams(u,true);u.searchParams.delete('ref');u.searchParams.delete('by');history.replaceState(history.state,'',u.toString())}
      var rt=D.getElementById('wlReturn');if(rt&&rt.value){var r=new URL(rt.value,location.origin);ownParams(r,true);rt.value=r.pathname+r.search}
    }catch(e){}},false);
    /* in-page unlock (#result loses .gated without a reload) */
    /* the result appears (a fresh finish may wait for the detail screens and the loading veil first) */
    try{var res=D.getElementById('result');if(res){var wasG=res.classList.contains('gated'),wasH=res.classList.contains('hidden');new MutationObserver(function(){
      var g=res.classList.contains('gated'),hd=res.classList.contains('hidden');
      if(g!==wasG){wasG=g;if(!g&&hasJoined())syncUrl(false)}
      if(hd!==wasH){wasH=hd;if(!hd){var fr=pendingFresh;pendingFresh=false;syncSoon(fr)}}
    }).observe(res,{attributes:true,attributeFilter:['class']})}}catch(e){}
    /* leaving: any link click, pagehide, tab hidden */
    D.addEventListener('click',function(ev){try{var t=ev.target,a=t&&t.closest?t.closest('a[href]'):null;if(a)save()}catch(e){}},true);
    W.addEventListener('pagehide',save);
    D.addEventListener('visibilitychange',function(){if(D.visibilityState==='hidden')save()});
    /* 5) back from bfcache: the page is as it was; keep the position if a script moved it */
    W.addEventListener('pageshow',function(e){if(!e.persisted)return;noSave=false;var r=saved();if(r&&shown()&&Math.abs((W.pageYOffset||0)-r.y)>40)W.scrollTo(0,r.y)});
  }
  if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',init);else init();
})();
